import { TabPane as TabPaneRc } from 'rc-tabs';
import { TabPaneProps } from 'rc-tabs/lib/TabPanelList/TabPane';

export interface ITabPaneProps extends TabPaneProps {}

const TabPane = TabPaneRc;

export default TabPane;
